import React, { useContext, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { GRNContext } from "../Context/GRNContext";

import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  Container,
  Button,
  Tooltip,
  Menu,
  MenuItem,
} from "@mui/material";

import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import MenuIcon from "@mui/icons-material/Menu";
import { FaArrowLeft, FaClipboardList } from "react-icons/fa";
import { useColorScheme } from "@mui/material/styles";

const pages = ["Home", "GRN Form", "GRN Records"];

function Header() {
  const { isAuthenticated, user, logout } = useContext(GRNContext);
  const navigate = useNavigate();
  const location = useLocation();

  const [anchorElUser, setAnchorElUser] = useState(null);
  const [anchorElNav, setAnchorElNav] = useState(null);

  const { mode, setMode } = useColorScheme();

  const handleToggle = () => {
    setMode(mode === "light" ? "dark" : "light");
  };

  if (!isAuthenticated) return null;

  const isOnRecordsPage = location.pathname === "/records";
  const buttonText = isOnRecordsPage
    ? "Back to GRN Submission"
    : "Check GRN Records";

  const handleButtonClick = () => {
    navigate(isOnRecordsPage ? "/" : "/records");
  };

  const newButtonText = "Check Scheduled Reminders";
  const handleNewButtonClick = () => {
    navigate("/scheduled-reminders");
  };

  const handleLogout = () => {
    logout();
    handleCloseUserMenu();
    navigate("/login");
  };

  const handleOpenUserMenu = (e) => setAnchorElUser(e.currentTarget);
  const handleCloseUserMenu = () => setAnchorElUser(null);
  const handleOpenNavMenu = (e) => setAnchorElNav(e.currentTarget);
  const handleCloseNavMenu = () => setAnchorElNav(null);

  const userName = user?.name || "User";

  return (
    <AppBar position="static" style={{ background: "#424141" }}>
      <Container maxWidth="xl" style={{ padding: "0px 15px" }}>
        <Toolbar
          disableGutters
          sx={{
            minHeight: "64px !important",
            height: "64px !important",
            px: 1,
          }}
        >
          <Box
            sx={{
              width: "20%",
              mr: 2,
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => {
              if (!isAuthenticated) {
                navigate("/");
              }
            }}
          >
            <img
              src="/images/plugin-logo.png"
              alt="plugin-logo"
              style={{ width: "100px", height: "50px" }}
            />
          </Box>

          <Box
            sx={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              textAlign: "center",
              display: { xs: "none", md: "block" },
            }}
          >
            <Typography
              variant="h5"
              noWrap
              sx={{
                fontFamily: "Open Sans",
                fontWeight: 700,
                color: "white",
                letterSpacing: ".5px",
              }}
            >
              GRN System
            </Typography>
          </Box>

          <Box
            sx={{
              display: { xs: "flex", md: "none" },
              width: "100%",
              alignItems: "center",
              justifyContent: "space-between",
              position: "relative",
            }}
          >
            <IconButton onClick={handleOpenNavMenu} sx={{ color: "white" }}>
              <MenuIcon />
            </IconButton>

            <Box
              component={Link}
              to="/"
              sx={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                display: "flex",
                alignItems: "center",
              }}
            >
              <img
                src="/images/plugin-logo.png"
                alt="logo"
                style={{ height: "38px" }}
              />
            </Box>

            <IconButton
              onClick={handleOpenUserMenu}
              sx={{
                color: "#fff",
                backgroundColor: "rgba(255,255,255,0.08)",
                borderRadius: "0px",
                p: "6px",
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.18)",
                },
              }}
            >
              <AccountCircleIcon sx={{ fontSize: 30 }} />
            </IconButton>
          </Box>

          <Menu
            anchorEl={anchorElNav}
            open={Boolean(anchorElNav)}
            onClose={handleCloseNavMenu}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            PaperProps={{
              sx: {
                mt: 1,
                minWidth: 180,
                borderRadius: "10px",
                boxShadow: "0px 8px 20px rgba(0,0,0,0.15)",
              },
            }}
          >
            <MenuItem
              onClick={() => {
                navigate("/");
                handleCloseNavMenu();
              }}
            >
              GRN Form
            </MenuItem>

            <MenuItem
              onClick={() => {
                navigate("/records");
                handleCloseNavMenu();
              }}
            >
              GRN Records
            </MenuItem>

            <MenuItem
              onClick={() => {
                navigate("/scheduled-reminders");
                handleCloseNavMenu();
              }}
            >
              Scheduled Reminders
            </MenuItem>
          </Menu>

          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              gap: 2,
              ml: "auto",
            }}
          >
            
            <IconButton
              onClick={handleToggle}
              sx={{
                color: "white",
                mr: 1,
              }}
            >
              {mode === "dark" ? "☀️" : "🌙"}
            </IconButton>

            <Box
              sx={{
                height: "48px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
              }}
            >
              <Tooltip title="Profile">
                <IconButton onClick={handleOpenUserMenu}>
                  <AccountCircleIcon
                    style={{ color: "white", width: 40, height: 35 }}
                  />
                </IconButton>
              </Tooltip>

              <Typography
                variant="caption"
                sx={{
                  color: "white",
                  width: "100px",
                  textAlign: "center",
                }}
              >
                {userName}
              </Typography>
            </Box>

            <Menu
              sx={{ mt: "45px" }}
              anchorEl={anchorElUser}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              <MenuItem onClick={handleCloseUserMenu}>Account</MenuItem>
              <MenuItem onClick={handleCloseUserMenu}>Dashboard</MenuItem>
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default Header;
